import { ORANGELABEL_LOGO, BTCMAP_LOGO, ABIB_LOGO, isATM } from './MapHelpers';

// Source badge for a business listing: ATM emoji, BTCMap logo, or OrangeLabel
// logo. This triplet was duplicated across BusinessPopup, Sidebar and
// SearchBar (with slightly different sizes) — unified here.
//
// `size` selects a preset:
//   'sm' — SearchBar dropdown rows
//   'md' — BusinessPopup
//   'lg' — Sidebar cards
// `showAbibMember` renders the ABIB member badge beneath the OrangeLabel logo
// (BusinessPopup only; Sidebar shows ABIB separately in its header row).
const SIZE_CLASSES = {
  sm: { emoji: 'text-lg', btcmap: 'h-4 w-4', ol: 'h-4' },
  md: { emoji: 'text-lg', btcmap: 'h-4 w-4', ol: 'h-5' },
  lg: { emoji: 'text-xl', btcmap: 'h-5 w-5', ol: 'h-5' },
};

const SourceLogo = ({ business, size = 'md', showAbibMember = false }) => {
  const s = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  if (isATM(business)) {
    return <span className={s.emoji}>🏧</span>;
  }

  if (business.btc_map) {
    return (
      <img
        src={BTCMAP_LOGO}
        alt="BTCMap"
        title="Listed on BTCMap"
        className={`${s.btcmap} object-contain cursor-help`}
      />
    );
  }

  return (
    <>
      <img
        src={ORANGELABEL_LOGO}
        alt="OrangeLabel"
        title="Listed on OrangeLabel"
        className={`${s.ol} cursor-help`}
      />
      {showAbibMember && business.abib_member && (
        <img
          src={ABIB_LOGO}
          alt="ABIB Member"
          title="Australian Bitcoin Industry Body Member"
          className="h-8 cursor-help"
        />
      )}
    </>
  );
};

export default SourceLogo;
